import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ConsTypeDonorDocument from './cons-type-donor-document';
import ConsTypeDonorDocumentDetail from './cons-type-donor-document-detail';
import ConsTypeDonorDocumentUpdate from './cons-type-donor-document-update';
import ConsTypeDonorDocumentDeleteDialog from './cons-type-donor-document-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ConsTypeDonorDocumentUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ConsTypeDonorDocumentUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ConsTypeDonorDocumentDetail} />
      <ErrorBoundaryRoute path={match.url} component={ConsTypeDonorDocument} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ConsTypeDonorDocumentDeleteDialog} />
  </>
);

export default Routes;
